import 'core-js/actual/object';
// @ts-ignore
import ClipboardJS from 'clipboard';

import {
  getActivityConfig,
  getCurrentUrl,
  getPandoraData,
  isFacebook,
  isInstagram,
  isIOS,
  isQQ,
  isWeChat,
  miloEmit,
  registerDeeplinkButton,
} from './lib/utils';
import { getCurrentLanguage } from './lib/i18n';
import './index';
import { BagInfo, LuckyInfoList } from '../@types/act';

const CONST_DATA = {
  PANDORA_SHARE_KEY: 'shareKey', // 潘多拉分享数据的参数
  MAX_LOTTERY_TIMES: 5, // 最大抽奖次数
};

/**
 * 获取潘多拉数据
 */
const pandoraData = getPandoraData<pandoraDataType>(CONST_DATA.PANDORA_SHARE_KEY, {
  module: 'BagShare',
  appId: '2312',
  userName: '',
  bagId: '',
  playerHeadUrl: '',
});

console.log('pandoraData===>', pandoraData);
const bagId = pandoraData.bagId;

let currLotteryTimes = 0;
let lotteryTimes = 0;

/**
 * 页面结束
 */
function updatePageEnd() {
  app.is_act_end = true;
}

const gidMap = {
  3008674: {
    name: 'SNK - 橘右京',
    langKey: 'reward1',
    ignore: false,
  },
  3008675: {
    name: 'SNK - 夏洛特',
    langKey: 'reward2',
    ignore: false,
  },
  3008676: {
    name: '锦鲤 - 限时点券',
    langKey: 'reward3',
    ignore: true,
  },
  3008677: {
    name: '锦鲤 - 全英雄皮肤',
    langKey: 'reward4',
    ignore: true,
  },
  3008678: {
    name: '自选英雄N选1',
    langKey: 'reward5',
    ignore: false,
  },
  3008679: {
    name: '随机皮肤宝箱',
    langKey: 'reward6',
    ignore: false,
  },
  3008680: {
    name: '英雄碎片',
    langKey: 'reward7',
    ignore: false,
  },
  3008681: {
    name: 'SNK - 不知火舞',
    langKey: 'reward8',
    ignore: false,
  },
  3008682: {
    name: '随机英雄宝箱',
    langKey: 'reward9',
    ignore: false,
  },
};

/**
 * 获取抽奖数据
 */
function getBagInfoData(bagInfo: BagInfo) {
  currLotteryTimes = bagInfo.my.length + bagInfo.others.length;
  lotteryTimes = CONST_DATA.MAX_LOTTERY_TIMES - currLotteryTimes;
  const { my, others } = bagInfo;
  let tempList = [] as LuckyInfoList[];
  if (my.length > 0) {
    tempList = [
      {
        name: pandoraData.userName,
        time: my[0].time,
        gid: gidMap[my[0].gid].langKey,
      },
    ];
  }
  if (others.length !== 0) {
    let nowTime = Math.ceil(Date.now() / 1000);
    for (const other of others) {
      tempList.push({
        name: other.user.n,
        time: Number(other.time) || nowTime,
        gid: gidMap[other.gid].langKey,
      });
      if (gidMap[other.gid].ignore) {
        currLotteryTimes = currLotteryTimes - 1;
        lotteryTimes = CONST_DATA.MAX_LOTTERY_TIMES - currLotteryTimes;
      }
    }
  }
  return tempList;
}

/**
 * 页面初始话操作
 */
function initPage() {
  if (!bagId) {
    return;
  }
  miloEmit('3001551_buEXgX', '7FFoDh', {
    bagId,
    instanceid: 3001551,
  })
    .then((res) => {
      console.log('initPage', res);
      if (Number(res.iRet) !== 0) {
        console.error('请求报错 initData==>', res);
        return;
      }
      const httpData = res.jData.data;
      const faasData = httpData.data;
      if (faasData.code !== 0) {
        return;
      }
      const bagInfo = faasData.data.bagInfo;
      app.luckyList = getBagInfoData(bagInfo);
      app.lotteryBtnStatus = currLotteryTimes === CONST_DATA.MAX_LOTTERY_TIMES;
    })
    .catch((err) => {
      console.log(err);
    });
}

function onError(err: ErrorEvent) {
  console.error('Uncaught error:', err.error || err.message || err, err);
}

// 全局未捕获错误处理
window.addEventListener('error', onError);

(async function () {
  // 从链接中获取语言，如果无法获取则尝试从系统语言中获取
  // app.invite_code = pandoraData.code;
  // app.userName = pandoraData.userName;
  let lang = getCurrentLanguage(language_data, 'lang', 'langStr') || 'en';
  app.switchLanguage(lang);
  let jumpPandoraData = { ...pandoraData };
  jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
  registerDeeplinkButton(
    '.jump_game',
    jumpPandoraData,
    () => {
      console.log('成功跳转~');
    },
    () => {
      console.log('失败跳转~');
      // if ((isIOS() && (isFacebook() || isInstagram())) || isWeChat() || isQQ()) {
      if (isFacebook() || isInstagram() || isWeChat() || isQQ()) {
        app.tip_browser = 'center';
        return false;
      }
    },
    () => {
      if (lotteryTimes === 0) {
        return false;
      }
    },
  );

  // 复制链接
  new ClipboardJS('.btn-copy', {
    text() {
      const content = getCurrentUrl();
      console.log('[Act] 触发复制事件~');
      return content || '';
    },
  });

  await getActivityConfig(
    'a20240529hoklqfdndj',
    {
      instanceid: 3000644,
    },
    (data) => {
      console.log('拉取配置成功~==>', data);
      const { now, iActivityEndTime } = data;
      if (now >= iActivityEndTime) {
        // 活动结束
        updatePageEnd();
      } else {
        initPage();
      }
    },
    (error) => {
      console.error('拉取配置失败~', error);
      initPage();
    },
  );
})();
